module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.ecdd509.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Bold.eot
// module id = 196
// module chunks = 1